import { Routes } from "@angular/router";
import { ErrorPageComponent } from './common/errorHandling/errorPage.component';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeClassicComponent } from './homeClassic/homeClassic.component';
import { LoginComponent } from './login/login.component';
import { DashboardDirectComponent } from './dashboardDirect/dashboardDirect.component';
import { NoveltyMaintenanceComponent } from './novelties/components/novelty-maintenance/novelty-maintenance.component';
import { LoginSuccessComponent } from './loginSuccess/loginSuccess.component';
import { DashboardRecruitmentCenterComponent } from './dashboard-recruitment/pages/dashboard-recruitment-center/dashboard-recruitment-center.component';
import { VacanciesComponent } from './vacancies/pages/vacancies/vacancies.component';
import { AuthGuard } from "./auth/guards/auth.guard";

export const appRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'loginSuccess',
    component: LoginSuccessComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'dashboard/direct',
    component: DashboardDirectComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'dashboard/recruitment',
    component: DashboardRecruitmentCenterComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'home',
    component: HomeClassicComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'tour/dashboard',
    component: DashboardComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'tour/home',
    component: HomeClassicComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'novelty/maintenance',
    component: NoveltyMaintenanceComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'vacancies',
    component: VacanciesComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
